import connection from '../utils/api';

export const getUserPackage = (id, type) => connection.get(`admin-updates/${id}?company_type=${type}`)
export const updateUserPackage = (id, data) => connection.put(`admin-updates/${id}`, data);
export const credentialManager = (data) => connection.post('credential-manager', data)
export const findUserByEmail = (email) => connection.get(`credential-manager?email=${email}`)
